/* eslint-disable no-console */
import BaseService from './services/BaseService';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const w = window as any;

//#region Google Font Test
const gfontUrl = (name: string) => `https://fonts.googleapis.com/css2?family=${name.replace(/ /g, '+')}:wght@400;500;700&display=swap`;

// Sets the font for the entire site for testing purposes, as a google font
w.testFont = (name: string | null | undefined) => {
  let testFontLink = document.head.querySelector<HTMLLinkElement>('#test-font');
  if (name) {
    if (!testFontLink) {
      testFontLink = document.createElement('link');
      testFontLink.id = 'test-font';
      testFontLink.rel = 'stylesheet';
      document.head.appendChild(testFontLink);
    }

    testFontLink.href = gfontUrl(name);
  } else {
    testFontLink?.remove();
  }

  let testFontStyle = document.head.querySelector<HTMLStyleElement>('#test-font-style');
  if (name) {
    if (!testFontStyle) {
      testFontStyle = document.createElement('style');
      testFontStyle.id = 'test-font-style';
      document.head.appendChild(testFontStyle);
    }

    testFontStyle.innerHTML = `
        * { font-family: '${name}' !important; }
    `;
  } else {
    testFontStyle?.remove();
  }
};
//#endregion

//#region Debug HTTP Service
w.__pbkHttpService = () => {
  if (!w.allowDebug) return;

  return wrappedBaseService();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyFn = (...args: any[]) => any;

/**
 * Clones `obj` and wraps each method so that calling it logs the promise result.
 * - Logs: method name, args, resolved value
 * - Also logs rejections
 * - Preserves `this` binding (works for methods that use `this`)
 */
export function wrappedBaseService(): BaseService {
  const clone = Object.create(Object.getPrototypeOf(BaseService));
  Object.assign(clone, BaseService);

  // Cache wrappers so repeated reads return the same wrapped function
  const wrapped = new Map<PropertyKey, AnyFn>();

  return new Proxy(clone, {
    get(target, prop, receiver) {
      const value = Reflect.get(target, prop, receiver);

      if (typeof value !== 'function') return value;

      if (wrapped.has(prop)) return wrapped.get(prop)!;

      // Wrap the function call
      const fn = value as AnyFn;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const wrapper = function (this: any, ...args: any[]) {
        // Call with the "this" that the caller expects
        const p = fn.apply(this, args) as Promise<unknown>;

        // Log resolved + rejected outcomes
        p.then(
          (result) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            console.log(`[${String(prop).toUpperCase()} ${args[0]}]:`, (result as any).data);
            return result;
          },
          (error) => {
            console.log(`[${String(prop).toUpperCase()} ${args[0]}]:`, { error });
            throw error;
          },
        );

        return p;
      };

      wrapped.set(prop, wrapper);
      return wrapper;
    },
  });
}

//#endregion
